exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td {\n  vertical-align: middle;\n}\n\n.version {\n  font-size: 12px;\n  color: #888;\n}\n\n.category {\n  padding: 1px 6px;\n  border: 1px solid currentColor;\n  border-radius: 3px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cat-NewFeature {\n  color: #00a65a;\n}\n\n.cat-Improvement {\n  color: #007bff;\n}\n\n.cat-Fix {\n  color: #f39c12;\n}\n\n.state {\n  padding: 1px 4px;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.state-Published {\n  background: #00a65a;\n}\n\n.state-Draft {\n  background: #777;\n}\n\n.state-Scheduled {\n  background: #f39c12;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/whats-new/whats-new-list/whats-new-list.component.css
// module id = ../../../../../src/app/main/pages/whats-new/whats-new-list/whats-new-list.component.css
// module chunks = main